import type { CuratedStory, Image } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface SingleStoryDefaultIntegrityProps {
    items?: CuratedStory[];
    image?: Image;
}

export default function integrityCheck({
    items = [],
    image,
}: SingleStoryDefaultIntegrityProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(items);

    if (items?.length) {
        const { eyebrow, type, byline, image: contentImage } = items[0];

        if (!image?.baseUrl && !contentImage?.baseUrl) {
            messages.push("Missing image baseUrl");
        }

        if (type !== "article" && !byline) messages.push("Missing byline");

        if (!eyebrow) messages.push("Missing eyebrow");
    }

    return messages;
}
